import { useQuery, useInfiniteQuery } from "@tanstack/react-query";
import { fetchSubcategories } from "../services/catalogs";

// Постраничный запрос
export const useSubcategoriesQuery = (
  category_id: string,
  search: string = "",
  page: number,
  limit: number,
  options?: {
    enabled?: boolean;
  }
) => {
  return useQuery({
    refetchOnWindowFocus: false,
    queryKey: ["subcategories", search, page, limit],
    queryFn: () =>
      fetchSubcategories({
        category_id,
        search,
        limit,
        offset: (page - 1) * limit,
      }),
    retry: 0,
    enabled: options?.enabled ?? true,
  });
};

// Бесконечная прокрутка
export const useSubcategoriesInfiniteQuery = (
  category_id: string,
  search: string = "",
  limit: number,
  options?: {
    enabled?: boolean;
  }
) => {
  return useInfiniteQuery({
    queryKey: ["subcategories-infinite", category_id, search, limit],
    queryFn: ({ pageParam = { category_id, limit: limit, offset: 0 } }) =>
      fetchSubcategories({
        category_id: category_id,
        search: search || undefined,
        limit: pageParam.limit,
        offset: pageParam.offset,
      }),
    initialPageParam: { limit: limit, offset: 0 },
    getNextPageParam: (lastPage, allPages) => {
      const totalLoaded = allPages.reduce(
        (acc, page) => acc + page.list.length,
        0
      );
      const hasMore = lastPage.list.length === limit;
      return hasMore ? { limit: limit, offset: totalLoaded } : undefined;
    },
    retry: 0,
    enabled: options?.enabled ?? true,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
};
